import axios from 'axios';
import {
    DATA_MANAGEMENT_STATISTICS_REQUEST,
    DATA_MANAGEMENT_STATISTICS_SUCCESS,
    DATA_MANAGEMENT_STATISTICS_FAIL,
    DATA_MANAGEMENT_PREVIEW_SUBJECTS_REQUEST,
    DATA_MANAGEMENT_PREVIEW_SUBJECTS_SUCCESS,
    DATA_MANAGEMENT_PREVIEW_SUBJECTS_FAIL,
    DATA_MANAGEMENT_PREVIEW_SUBJECTS_RESET,
    DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_REQUEST,
    DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_SUCCESS,
    DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_FAIL,
    DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_RESET,
    DATA_MANAGEMENT_PREVIEW_PATIENTS_REQUEST,
    DATA_MANAGEMENT_PREVIEW_PATIENTS_SUCCESS,
    DATA_MANAGEMENT_PREVIEW_PATIENTS_FAIL,
    DATA_MANAGEMENT_PREVIEW_PATIENTS_RESET,
    DATA_MANAGEMENT_CLEAR_SUBJECTS_REQUEST,
    DATA_MANAGEMENT_CLEAR_SUBJECTS_SUCCESS,
    DATA_MANAGEMENT_CLEAR_SUBJECTS_FAIL,
    DATA_MANAGEMENT_CLEAR_SUBJECTS_RESET,
    DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_REQUEST,
    DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_SUCCESS,
    DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_FAIL,
    DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_RESET,
    DATA_MANAGEMENT_CLEAR_PATIENTS_REQUEST,
    DATA_MANAGEMENT_CLEAR_PATIENTS_SUCCESS,
    DATA_MANAGEMENT_CLEAR_PATIENTS_FAIL,
    DATA_MANAGEMENT_CLEAR_PATIENTS_RESET,
} from '../constants/dataManagementConstants';

const getAuthConfig = (token) => ({
    headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${token}`
    }
});

const formatErrorMessage = (error) => {
    const errorMessages = [];
    if (error.response) {
        if (error.response.data) {
            if (error.response.data.detail) {
                if (Array.isArray(error.response.data.detail)) {
                    error.response.data.detail.forEach((detail) => {
                        errorMessages.push(detail);
                    });
                } else {
                    errorMessages.push(error.response.data.detail);
                }
            } else if (error.response.data.message) {
                errorMessages.push(error.response.data.message);
            } else if (error.response.data.error) {
                errorMessages.push(error.response.data.error);
            }
        }
    }
    return errorMessages.length > 0
        ? errorMessages
        : [error.message || "An error occurred, please try again later"];
};

const API_BASE_URL = '/dotnet_api/v1/DataManagement';

export const getDataManagementStatistics = () => async (dispatch, getState) => {
    try {
        dispatch({ type: DATA_MANAGEMENT_STATISTICS_REQUEST });
        const config = getAuthConfig(getState().userLogin.userInfo.token);
        const { data } = await axios.get(`${API_BASE_URL}/statistics`, config);
        dispatch({ type: DATA_MANAGEMENT_STATISTICS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: DATA_MANAGEMENT_STATISTICS_FAIL,
            payload: formatErrorMessage(error)[0]
        });
    }
};

export const previewSubjects = (startDate, endDate) => async (dispatch, getState) => {
    try {
        dispatch({ type: DATA_MANAGEMENT_PREVIEW_SUBJECTS_REQUEST });
        const config = getAuthConfig(getState().userLogin.userInfo.token);
        const { data } = await axios.post(
            `${API_BASE_URL}/preview-subjects`,
            { startDate, endDate },
            config
        );
        dispatch({ type: DATA_MANAGEMENT_PREVIEW_SUBJECTS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: DATA_MANAGEMENT_PREVIEW_SUBJECTS_FAIL,
            payload: formatErrorMessage(error)[0]
        });
    }
};

export const resetPreviewSubjects = () => (dispatch) => {
    dispatch({ type: DATA_MANAGEMENT_PREVIEW_SUBJECTS_RESET });
};

export const previewUploadBatches = (startDate, endDate) => async (dispatch, getState) => {
    try {
        dispatch({ type: DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_REQUEST });
        const config = getAuthConfig(getState().userLogin.userInfo.token);
        const { data } = await axios.post(
            `${API_BASE_URL}/preview-upload-batches`,
            { startDate, endDate },
            config
        );
        dispatch({ type: DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_FAIL,
            payload: formatErrorMessage(error)[0]
        });
    }
};

export const resetPreviewUploadBatches = () => (dispatch) => {
    dispatch({ type: DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_RESET });
};

export const previewPatients = (startDate, endDate) => async (dispatch, getState) => {
    try {
        dispatch({ type: DATA_MANAGEMENT_PREVIEW_PATIENTS_REQUEST });
        const config = getAuthConfig(getState().userLogin.userInfo.token);
        const { data } = await axios.post(
            `${API_BASE_URL}/preview-patients`,
            { startDate, endDate },
            config
        );
        dispatch({ type: DATA_MANAGEMENT_PREVIEW_PATIENTS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: DATA_MANAGEMENT_PREVIEW_PATIENTS_FAIL,
            payload: formatErrorMessage(error)[0]
        });
    }
};

export const resetPreviewPatients = () => (dispatch) => {
    dispatch({ type: DATA_MANAGEMENT_PREVIEW_PATIENTS_RESET });
};

export const clearSubjects = (startDate, endDate) => async (dispatch, getState) => {
    try {
        dispatch({ type: DATA_MANAGEMENT_CLEAR_SUBJECTS_REQUEST });
        const config = getAuthConfig(getState().userLogin.userInfo.token);
        const { data } = await axios.post(
            `${API_BASE_URL}/clear-subjects`,
            { startDate, endDate },
            config
        );
        dispatch({ type: DATA_MANAGEMENT_CLEAR_SUBJECTS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: DATA_MANAGEMENT_CLEAR_SUBJECTS_FAIL,
            payload: formatErrorMessage(error)[0]
        });
    }
};

export const resetClearSubjects = () => (dispatch) => {
    dispatch({ type: DATA_MANAGEMENT_CLEAR_SUBJECTS_RESET });
};

export const clearUploadBatches = (startDate, endDate) => async (dispatch, getState) => {
    try {
        dispatch({ type: DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_REQUEST });
        const config = getAuthConfig(getState().userLogin.userInfo.token);
        const { data } = await axios.post(
            `${API_BASE_URL}/clear-upload-batches`,
            { startDate, endDate },
            config
        );
        dispatch({ type: DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_FAIL,
            payload: formatErrorMessage(error)[0]
        });
    }
};

export const resetClearUploadBatches = () => (dispatch) => {
    dispatch({ type: DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_RESET });
};

export const clearPatients = (startDate, endDate) => async (dispatch, getState) => {
    try {
        dispatch({ type: DATA_MANAGEMENT_CLEAR_PATIENTS_REQUEST });
        const config = getAuthConfig(getState().userLogin.userInfo.token);
        const { data } = await axios.post(
            `${API_BASE_URL}/clear-patients`,
            { startDate, endDate },
            config
        );
        dispatch({ type: DATA_MANAGEMENT_CLEAR_PATIENTS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: DATA_MANAGEMENT_CLEAR_PATIENTS_FAIL,
            payload: formatErrorMessage(error)[0]
        });
    }
};

export const resetClearPatients = () => (dispatch) => {
    dispatch({ type: DATA_MANAGEMENT_CLEAR_PATIENTS_RESET });
};


